module.exports = __webpack_public_path__ + "img/135.6.7367368b.png";